

export class VehicleCompanyAddInput implements IVehicleCompanyAddInput {
    /** The vehicle company name with 255 character limit */
    vehicleCompanyName!: string;

    constructor(data?: IVehicleCompanyAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleCompanyName = _data["vehicleCompanyName"];
        }
    }

    static fromJS(data: any): VehicleCompanyAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleCompanyAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleCompanyName"] = this.vehicleCompanyName;
        return data; 
    }
}

export interface IVehicleCompanyAddInput {
    /** The vehicle company name with 255 character limit */
    vehicleCompanyName: string;
}

